import { take, call, put, fork } from 'redux-saga/effects'
import fetchApi from '../../../../utils/fetchApi'

function* getAllDelegatesFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload } = yield take('GET_ALL_DELEGATES')
    try {
      const res = yield call(fetchApi, `Accounts?filter=${JSON.stringify(payload.filter)}`)
      if (res.error) {
        throw res.error
      }
      yield put({ type: 'GET_ALL_DELEGATES_SUCCESS', payload: res })
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* addDelegateFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload, resolve, reject } = yield take('ADD_DELEGATE')
    try {
      delete payload.confirmPassword
      const res = yield call(fetchApi, 'Accounts', payload, { method: 'POST' })
      if (res.error) {
        throw res.error
      }
      resolve()
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
      reject(err)
    }
  }
}

function* deleteDelegateFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload: id, resolve, reject } = yield take('DELETE_DELEGATE')
    try {
      const res = yield call(fetchApi, `Accounts/${id}`, null, { method: 'DELETE' })
      if (res.error) {
        throw res.error
      }
      resolve()
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
      reject(err)
    }
  }
}

function* resetPwdDelegateFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload, resolve, reject } = yield take('RESET_PASSWORD_DELEGATE')
    try {
      const res = yield call(
        fetchApi,
        `Accounts/${payload.id}/changeDelegatePwd`,
        { newPassword: payload.password },
        { method: 'POST' }
      )
      if (res.error) {
        throw res.error
      }
      resolve()
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
      reject(err)
    }
  }
}

export default function*() {
  yield fork(getAllDelegatesFlow)
  yield fork(addDelegateFlow)
  yield fork(deleteDelegateFlow)
  yield fork(resetPwdDelegateFlow)
}



// WEBPACK FOOTER //
// ./routes/app/routes/delegate-list/saga.js